import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';

const BSLARedCockadedWoodpeckerLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        url: 'https://utility.arcgis.com/usrsvcs/servers/a7bb873fcd134452bd0ff11d3c3f05a3/rest/services/RED_COCKADED_WOODPECKER_V2/FeatureServer/0',
        visible: false,
        title: 'Red Cockaded Woodpecker (FWC)',
        minScale: 10000000,
        popupTemplate: {
            outFields: ['*'],
            title: 'Red Cockaded Woodpecker (FWC)',
            content: (feature: __esri.Feature) => {
                const node = document.createElement('div');

                const content = (
                    <React.Fragment>
                        <div className="mb-1">
                            <p className="mb-1">
                                Issue: This layer shows documented observations of State and federally protected Red-Cockaded Woodpeckers (RCWs). Impacts to open pine forests near
                                RCW observations may require lengthy surveys, permitting time frames, and significant mitigation costs.
                            </p>
                            <p>
                                Cost: Surveys of suitable habitat to determine the RCW presence can cost $5,000 and up depending on parcel size and the number of surveys required.
                                Impacts to occupied RCW habitat often requires lengthy permitting time frames and face significant restrictions to land use. Mitigation for habitat
                                impacts is typically achieved by setting aside land on site or off as there are no mitigation credits currently available. Costs vary greatly based
                                on development site, land prices, and permitting complexity. Seek professional guidance from a reputable environmental consultant before purchasing
                                land near known RCW observations.
                            </p>
                        </div>
                        <BSLAExternalLinkComponent href="http://myfwc.com/wildlifehabitats/imperiled/profiles/birds/red-cockaded-woodpecker" />
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLARedCockadedWoodpeckerLayer;
